module.exports = __webpack_public_path__ + "img/img.a0fbb66b.png";